import { render, staticRenderFns } from "./LoginFake.vue?vue&type=template&id=6e5de5db&scoped=true&"
import script from "./LoginFake.vue?vue&type=script&lang=js&"
export * from "./LoginFake.vue?vue&type=script&lang=js&"
import style0 from "./LoginFake.vue?vue&type=style&index=0&id=6e5de5db&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e5de5db",
  null
  
)

export default component.exports